import ConfirmIcon from '~/assets/icons/confirm-icon-indicador.png';
import CancelIcon from '~/assets/icons/cancel-icon-indicador.png';

/**
 * ---------------------------------------------------
 *   LINHAS DE CUIDADO
 * ---------------------------------------------------
 */

export const modalConfirm = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${ConfirmIcon} /><h2>
          <span>Ativar a coleta</span> da Linha de Cuidado</h2></div>
          <div class="bodyModalIndicador">
          <p>
          
          Você tem certeza que deseja ativar a coleta desta Linha de Cuidado? 
          Após confirmação, a Linha de cuidado ficará disponível para a inclusão de dados.
          
          </p></div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Ativar Linha de Cuidado',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const optionsModalCancel = {
  html: `<div>
      <div class="headerModalIndicador">
      <img src=${CancelIcon} />
      <h2><span>Inativar a coleta da</span><br /> Linha de Cuidado?</h2></div>
      <div class="bodyModalIndicador">
      <p>Você tem certeza que deseja inativar a coleta desta Linha de Cuidado? Após confirmar, o sistema não estará mais
      disponível para inclusão de dados desta Linha de Cuidado. Caso
      a sua instituição deseje voltar a coletar futuramente, será
      possível reativá-lo no botão de Status.</p>
      </div></div>`,
  showCancelButton: true,
  confirmButtonColor: '#cc0000',
  cancelButtonColor: '#FFF',
  confirmButtonText: 'Inativar Linha de Cuidado',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores',
    confirmButton: 'confirm-button-switch-indicadores',
    cancelButton: 'cancel-button-switch-indicadores',
  },
};

/**
 * ---------------------------------------------------
 *  INDICADORES DO PAINEL GERAL
 * ---------------------------------------------------
 */

export const modalConfirmIndicador = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${ConfirmIcon} /><h2>Ativar Indicador</h2></div>
          <div class="bodyModalIndicador">
          <p style="text-align: center">

          Você tem certeza que deseja ativar este indicador? 
          </p></div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Sim, ativar',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const modalCancelIndicador = {
  html: `<div>
      <div class="headerModalIndicador">
      <img src=${CancelIcon} />
      <h2><span>Inativar </span> Indicador?</h2></div>
      <div class="bodyModalIndicador">
      <p style="text-align: center">Você tem certeza que deseja inativar a coleta deste Indicador? </p>
      </div></div>`,
  showCancelButton: true,
  confirmButtonColor: '#cc0000',
  cancelButtonColor: '#FFF',
  confirmButtonText: 'Sim, inativar',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores',
    confirmButton: 'confirm-button-switch-indicadores',
    cancelButton: 'cancel-button-switch-indicadores',
  },
};

// ESTRATIFICAÇÕES

export const modalConfirmEstrat = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${ConfirmIcon} /><h2>Ativar Estratificação</h2></div>
          <div class="bodyModalIndicador">
          <p style="text-align: center">
          Você tem certeza que deseja ativar desta Estratificação? 
          </p></div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Sim, ativar',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const modalCancelEstrat = {
  html: `<div>
      <div class="headerModalIndicador">
      <img src=${CancelIcon} />
      <h2><span>Inativar </span> Estratificação?</h2></div>
      <div class="bodyModalIndicador">
      <p style="text-align: center">Você tem certeza que deseja inativar a coleta desta Estratificação? </p>
      </div></div>`,
  showCancelButton: true,
  confirmButtonColor: '#cc0000',
  cancelButtonColor: '#FFF',
  confirmButtonText: 'Sim, inativar',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores',
    confirmButton: 'confirm-button-switch-indicadores',
    cancelButton: 'cancel-button-switch-indicadores',
  },
};
